module.exports = __webpack_public_path__ + "static/media/cheesecake.7bd6d2ce.jpg";